import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { Observable } from 'rxjs';
import { ApiClient } from '@monsido/modules/endpoints/api/api-client';
import { BaseRepo, BaseRepoRequestType } from '@client/app/services/api/base-repo/base-repo';
import { RequestOptionsType, RequestParamsType } from '@monsido/ng2/external/http/options';

type ExportRequestType = RequestParamsType & BaseRepoRequestType;

interface ExportPayload {
    params?: Record<string, unknown>;
    [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class ExportService extends BaseRepo {

    constructor (private client: ApiClient, protected sessionService: SessionService) {
        super();
    }

    /**
     * Ensure all exports have a params object
     */
    private addRequiredParams (data: ExportPayload): ExportPayload {
        return { ...data, params: data.params || {} };
    }

    public create (data: unknown): Observable<unknown> {
        const payload = this.addRequiredParams(data as ExportPayload);
        return this.client.postObservable('exports', payload);
    }

    public get (exportId: number, params: ExportRequestType = {}): Observable<unknown> {
        params = this.setGroupId(params);
        const options: RequestOptionsType = {
            params,
        };
        return this.client.getObservable('exports/' + exportId, options);
    }

    public getExports (params: ExportRequestType = {}): Observable<unknown> {
        params = this.setGroupId(params);
        const options: RequestOptionsType = {
            params,
        };
        return this.client.getObservable('exports', options);
    }
}
